import React from "react";
import { Table } from "antd";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";

const DeletedResultHierarchyModal = ({
  isDeleteHierarchyResult,
  toggleDeleteHierarchyResult,
  columnsHierarchyResult,
  deletehierarchyListDataResult,
  programId,
  history,
}) => {
  return (
    <>
      <Modal
        className={`modal-event-delete-hierarchy-list modal-lg`}
        isOpen={isDeleteHierarchyResult}
        toggle={toggleDeleteHierarchyResult}
        onClosed={() => {
          history.push(`/program/view/${programId}`);
        }}
      >
        <ModalHeader>
          <div>This event deleted from the following programs</div>
        </ModalHeader>
        <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
          <Table
            pagination={false}
            rowKey="id"
            columns={columnsHierarchyResult}
            dataSource={deletehierarchyListDataResult}
          />
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeletedResultHierarchyModal;
